import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Rx";
import { CaseSearchInput, Case } from "./app.entities";
import * as $ from "jquery";

const caseLookupApiUrl = "/api/kwiksetsupport";
const caseSearchRoute = "/searchforcasekey";
const caseDetailRoute = "/getcasedetails";
const caseAttachmentRoute = "/addcaseattachment";
const caseCommentRoute = "/AddCaseComment";

@Injectable()
export class AppService {    

    constructor(private readonly httpClient: HttpClient) { }
   
    searchForCaseKey(caseSearchInput: CaseSearchInput): Observable<string> {
        const serializedModel = $.param(caseSearchInput);
        return this.httpClient
            .get<string>(`${caseLookupApiUrl}${caseSearchRoute}?${serializedModel}`);
    }
    // since key sent in url has to be encoded for special characters
    getCaseDetails(key: string): Observable<Case> {
        return this.httpClient
            .get<Case>(`${caseLookupApiUrl}${caseDetailRoute}?key=${encodeURIComponent(key)}`);
    }

    addMessageToCase(key: string, comment: string): Observable<Case> {
        const url = `${caseLookupApiUrl}${caseCommentRoute}`;
        const formData = new FormData();
        formData.append("id", key);
        formData.append("comment", comment);
        return this.httpClient
            .post<Case>(url, formData, { headers: new HttpHeaders()});
    }

    addDocumentToCase(id: string, comment: string, filesToUpload: any): Observable<Object> {
        const url = `${caseLookupApiUrl}${caseAttachmentRoute}`;
        const formData = new FormData();
        formData.append("id", id);
        formData.append("comment", comment);
        for (var i = 0; i < filesToUpload.length; i++)
        formData.append("Files" + i, filesToUpload[i]);
       

        return this.httpClient
            .post(url, formData, { headers: new HttpHeaders() });
    }
}


// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/app.service.ts